<template>
  <div class="full-content" style="position:relative;">
    <div class="bg-just" :style="{ position: 'absolute', width: '954px',height: '561px', left: '567px', margin:'auto' ,backgroundImage: 'url(/static/img/ucs.png)' }">
      <div v-for="(item,$index) in ucsDes" :key="$index" >
        <div
          class="point"
          :style="{ left: item.left, top: item.top, width: '50px', height: '50px' }"
          @mouseover="showText($index)"
          @mouseout="hideText($index)">
          <span class="point p1" :style="{ width: '25px', height: '25px' }"></span>
          <span class="point p2"></span>
          <span class="point p3"></span>
          <div :class="{ 'des': true, 'hide' : item.hide, 'display-animate': !item.hide }" :style="item.des.style">
            <div class="des-text flex-center font18" :style="item.des.text.style">
              {{item.des.text.text}}
            </div>
            <svg :width="item.des.svg.width" :height="item.des.svg.height" :viewBox="item.des.svg.viewBox">
              <polyline class="line-animate-stroke line-animate" :points="item.des.svg.points" stroke-width="1" stroke="#FF2A00" fill="none" stroke-linecap="round" />
            </svg>
          </div>
        </div>
      </div>
    </div>
    <div class="flex-center m-w w100 supermarket-des scroll-animate"
         data-animate-method="animateNum"
         style="padding: 0 100px;margin: 0 auto;box-sizing:border-box;">
      <div class="w25 w25-list flex-col-center bg-grey"
           style="height: 140px;"
           v-for="(item, $index) in marketIntros"
           :key="$index">
        <div class="red">
          <span class="font50 lighter">{{item.value}}</span><!--
                    --><span class="font24">{{item.unit}}</span>
        </div>
        <span class="font20 c3">{{item.des}}</span>
      </div>
    </div>
  </div>
</template>

<script>
  import VueScroll from '@/api/animateDom'
  import BezierCurve from '@/api/bezier'

  export default {
    data(){
      return {
        marketIntros:[
          { value: 0, endValue: 24, unit: 'h', des: '24小时无人值守', time: 2400 },
          { value: 0, endValue: 15, unit: 'm²', des: '建筑面积', time: 1500 },
          { value: 0, endValue: 10, unit: 'w', des: '建设成本', time: 1000 },
          { value: 0, endValue: 30, unit: '%', des: '利率', time: 3000 }
        ],
        ucsDes:[
          {
            hide: true,
            left: '48px',
            top: '158px',
            des:{
              style:{
                left: 'calc(-250px + 25px)',
                top: 'calc(-90px + 25px)',
              },
              text:{
                style:{
                  left: '0',
                  top: '10px',
                },
                text: '在线自助结算系统',
              },
              svg:{
                width: 250,
                height: 90,
                points: '250,90 160,0 0,0',
                viewBox: '0 0 250 90',
                style:{

                }
              }
            },
          },
          {
            hide: true,
            left: '254px',
            top: '236px',
            des:{
              style:{
                width: '500px',
                left: 'calc(-500px + 25px)',
                top: '25px',
              },
              text: {
                style:{
                  left: '0',
                  top: '10px',
                },
                text: '用户扫码开门',
              },
              svg:{
                width: 500,
                height: 90,
                points: '500,0 160,0 0,0',
                viewBox: '0 0 500 90',
                style:{

                }
              }
            }
          },
          {
            hide: true,
            left: '499px',
            top: '166px',
            des:{
              style:{
                left: '25px',
                top: '25px'
              },
              text: {
                style:{
                  right: '-200px',
                  top: 'calc(-40px + -10px)',
                },
                text: '动态智能货架',
              },
              svg:{
                width: 450,
                height: 90,
                points: '0,0 160,0 450,0',
                viewBox: '0 0 450 90',
                style:{

                }
              }
            },
          },
          {
            hide: true,
            left: '645px',
            top: '40px',
            des:{
              style:{
                left: '25px',
                top: 'calc(-90px + 25px)'
              },
              text: {
                text: '24小时无人值守',
                style:{
                  right: '0',
                  top: '10px'
                }
              },
              svg:{
                width: 250,
                height: 90,
                points: '0,90 90,0 250,0',
                viewBox: '0 0 250 90',
                style:{

                }
              }
            }
          }
        ]
      }
    },
    mounted() {
      this.vueScroll = new VueScroll(this, {
        delay: 300
      });
      this.vueScroll.run();
    },
    methods:{
      animateNum(){
        for(var index in this.marketIntros) {
          ((val)=>{
            animateNumber(val.value, val.endValue, val.time, (num)=>{
              val.value = num
            });
          })(this.marketIntros[index]);
        }
      },
      showText(index){
        this.ucsDes[index].hide = false;
      },
      hideText(index){
        this.ucsDes[index].hide = true;
      }
    }
  }

  function animateNumber(from, to, duration, outFn) {

    var bezierFn = new BezierCurve({
      time: duration,
      to,
      from,
      outFn
    })

    bezierFn.runWithCalc();
  }
</script>

<style scoped>
  @import '../../static/css/point.css';

  .supermarket-des {
    position: absolute;
    bottom: 100px;
    left: 0;
    right: 0;
    bottom: 0;
  }

  .des {
    width: 250px;
    height: 90px;
    position: relative;
  }

  .des-text {
    width: 160px;
    height: 40px;
    position: absolute;
    background-color: #FF2A00;
    color: #fff;
  }

  .des-text::after{
    content: '';
    border: 5px solid transparent;
    position: absolute;
    right: 0;
    top: 0;
    border-right: 5px solid #fff;
    border-top: 5px solid #fff;
  }

  .line-top {
    border-top: 1px solid #FF2A00;
  }

  .bias {
    position: absolute;
    left: 160px;
    width: 90px;
    height: 90px;
    transform: rotate(45deg);
  }

  .bias-line{
    width: 100%;
    height: 0;
    border-top: .9px solid #FF2A00;
    position: absolute;
    top: 0;
    bottom: 0;
    margin:auto;
    transform: scaleX(1.41421356);
  }

  .line-animate-stroke {
    stroke-dasharray: 500 500;
    stroke-dashoffset: 0;
  }

  .display-animate .line-animate-stroke{
    animation: lineAnimate 1s linear;
  }

  .display-animate .des-text{
    animation: fadeIn 2s linear;
  }


  @keyframes delayShow {
    from {
      opacity: 0;
    }
    50%{
      opacity: 0;
    }
    to{
      opacity: 1;
    }
  }

  @keyframes lineAnimate {
    from{
      stroke-dashoffset: 500;
    }
    to{
      stroke-dashoffset: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/SuperMarket.vue